<div class="slider-wrapper">
  <!-- Prev button -->
  <button class="slider-nav slider-nav--prev" (click)="prevSlide()" [disabled]="currentSlideIndex === 0" aria-label="Previous">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="slider-viewport">
    <div class="slider-cards" [style.--items-per-view]="itemsPerView">
      <ng-container *ngFor="let item of visibleItems">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              $implicit: item,
              index: currentSlideIndex,
              isLastSlide: currentSlideIndex + itemsPerView >= items.length
            }
          "
        >
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Next button -->
  <button
    class="slider-nav slider-nav--next"
    (click)="nextSlide()"
    [disabled]="currentSlideIndex + itemsPerView >= items.length"
    aria-label="Next"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>

<!-- Dot indicators — one per slide -->
<div class="slider-dots-container">
  <div class="slider-dots">
    <button
      *ngFor="let i of slideIndices"
      class="slider-dot"
      [class.slider-dot--active]="currentSlideIndex === i * itemsPerView"
      (click)="goToSlide(i)"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
  </div>
</div>
